<template>
    <div>
      <section class="section section-md bg-white text-center"> 
        <div class="shell">
          <div class="range range-md-center">
            <div class="cell-md-11 cell-xl-10">
              <h2 class="text-bold">Kontaktirajte nas</h2>
              <p><span class="box-width-2">Pošaljite nam upit za Vaš događaj a mi ćemo odgovoriti u što kraćem roku.</span></p>
              <div class="layout-columns"> 
                <div class="layout-columns__main contact-left">
                  <div class="layout-columns__main-inner">
                    <form class="rd-mailform">
                      <div class="form-wrap" :class="{has_error: inputElements[0].hasError}">
                        <input v-model="inputElements[0].value" class="form-input" @focus="inputElements[0].isOnFocus=true" @blur="checkIfIsNotEmpty()" type="text" name="ime">
                        <span :class="{hidden: !inputElements[0].hasError}" class="form-validation">Molimo upišite ime i prezime</span>
                        <label :class="{focus: inputElements[0].isOnFocus}" class="form-label" for="contact-name">Ime i prezime</label>
                      </div>
                      <div class="form-wrap" :class="{has_error: inputElements[1].hasError}">
                        <input v-model="inputElements[1].value" class="form-input" @focus="inputElements[1].isOnFocus=true" @blur="checkIfIsNotEmpty()" type="email" name="email">
                        <span :class="{hidden: !inputElements[1].hasError}" class="form-validation">Molimo upišite ispravnu email adresu</span>
                        <label :class="{focus: inputElements[1].isOnFocus}" class="form-label" for="contact-email">E-mail</label>
                      </div>
                      <div class="form-wrap" :class="{has_error: inputElements[2].hasError}">
                        <label :class="{focus: inputElements[2].isOnFocus}" class="form-label" for="contact-message">Poruka</label>
                        <textarea data-gramm="false" v-model="inputElements[2].value" class="form-input" @focus="inputElements[2].isOnFocus=true" @blur="checkIfIsNotEmpty()" name="poruka"></textarea>
                        <span :class="{hidden: !inputElements[2].hasError}" class="form-validation">Molimo upišite poruku</span>
                      </div>
                      <div class="form-wrap">
                        <p class="post-classic__title" style="color: #a7cf38; font-size:18px;">{{ emailSuccessMsg }}</p>
                      </div>
                      <div class="form-wrap form-button offset-1">
                        <button v-on:click="posaljiUpit()" class="button button-block button-primary-outline button-ujarak" type="button">Pošalji upit</button>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="layout-columns__aside contact-right">
                  <div class="layout-columns__aside-item">
                    <p class="heading-5">Društvene mreže</p>
                    <div class="divider-modern"></div>
                    <ul class="list-inline-xs">
                      <!-- <li><a class="icon" :href='this.instagramUrl' target="_blank"><img src="./../../icons/instagram.png" alt="SLight production instagram"/></a></li> -->
                      <li><a class="icon" :href='this.facebookUrl' target="_blank"><img src="./../../icons/facebook.png" alt="SLight production facebook"/></a></li>
                      <li><a class="icon" :href='this.youtubeUrl' target="_blank"><img src="./../../icons/youtube.png" alt="SLight production youtube"/></a></li>
                    </ul>
                  </div>
                  <div class="layout-columns__aside-item">
                    <p class="heading-5">Telefon</p>
                    <div class="divider-modern"></div>
                    <div class="unit unit-horizontal unit-spacing-xxs">
                      <div class="unit__left"><img src="./../../icons/phone.png" alt="SLight production phone"/></div>
                      <div class="unit__body"><a href="callto:#">+385 98 713 142</a></div>
                    </div>
                  </div>
                  <div class="layout-columns__aside-item">
                    <p class="heading-5">Adresa</p>
                    <div class="divider-modern"></div>
                    <div class="unit unit-horizontal unit-spacing-xxs">
                      <div class="unit__left"><img src="./../../icons/location.png" alt="SLight production phone"/></div>
                      <div class="unit__body"><a href="#">Toplička 12, Gornji Kneginec</a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>

<script>
import axios from 'axios';
export default {
   data(){
      return{
        inputElements: [ 
          {
            title:'ime',
            value: '',
            isOnFocus: false,
            hasError: false,
          },
          {
            title:'email',
            value: '',
            isOnFocus: false,
            hasError: false,
          },  
          {
            title:'poruka',
            value: '',
            isOnFocus: false,
            hasError: false,
          },
        ],
        emailSuccessMsg:''                   
      }
   },
   methods:{
      posaljiUpit: function() {
        const params = new URLSearchParams();
        params.append('name', this.inputElements[0].value);
        params.append('email', this.inputElements[1].value);
        params.append('message', this.inputElements[2].value);
        
        if(this.formValidate()){
          //Saljemo email
          axios({
            method: 'post',
            url: this.apiPath + 'sendEmail/sendEmail.php',
            data: params
          })
          .then(function(response) {
            this.emailSuccessMsg = response.data.message;
            if (response.data.result == true) {
                this.inputElements.forEach((item) => {
                  item.value = '';
                  item.isOnFocus = false;
                });   
                
                this.emailSuccessMsg = "Hvala, Vaš upit je zaprimljen. Odgovorit ćemo Vam u najkraćem mogućem roku!";
                
            }
          }
          .bind(this))
          .catch((error) => {
              console.log(error);
          });
        }
        
      }, 
      formValidate: function(){
        var validated = true;

        this.inputElements.forEach((item) => {
          //Reset input validation
          item.hasError = false;
          //Validate input field
          if(this.isNullOrEmpty(item.value)){
            item.hasError = true;
            validated = false;
          }else{
            item.isOnFocus = true;
          }          
        });  
        return validated ? true:false;  
      },      
      isNullOrEmpty: function(val){
        return (val === undefined || val == null || val.length <= 0) ? true : false;
      },
      checkIfIsNotEmpty(element){
        this.inputElements.forEach((item) => {
          this.isNullOrEmpty(item.value) ? item.isOnFocus = false:item.isOnFocus=true;
        });        
      }   
    },
    created(){

    }   
}
</script>

<style lang="scss">


.contact-right{
  .layout-columns__aside-item{
    ul{
      li{
        img{
          width:24px;
          &:hover{
            opacity:.8;
          }
        }
      }
    }
    .unit{
      .unit__left{
        width:24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Contact.vue